/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.AccountResource = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The AccountResource model module.
   * @module model/AccountResource
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>AccountResource</code>.
   * The resource includes the information of an account.
   * @alias module:model/AccountResource
   * @class
   * @param name {String} Required. The name of the account. It can't be duplicated, must be unique in the GIS Server.
   * @param nickName {String} Required. The nick name of the account.
   * @param email {String} Required. The Email address of the account. It can't be duplicated, must be unique in the GIS Server.
   * @param timeZone {String} The timezone of the account. It will be used to convert some data records datetime. For example, the statistics records. Defaults to \"UTC\".
   */
  var exports = function(name, nickName, email, timeZone) {
    var _this = this;

    _this['name'] = name;
    _this['nickName'] = nickName;
    _this['email'] = email;

    _this['timeZone'] = timeZone;

  };

  /**
   * Constructs a <code>AccountResource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AccountResource} obj Optional instance to populate.
   * @return {module:model/AccountResource} The populated <code>AccountResource</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('nickName')) {
        obj['nickName'] = ApiClient.convertToType(data['nickName'], 'String');
      }
      if (data.hasOwnProperty('email')) {
        obj['email'] = ApiClient.convertToType(data['email'], 'String');
      }
      if (data.hasOwnProperty('description')) {
        obj['description'] = ApiClient.convertToType(data['description'], 'String');
      }
      if (data.hasOwnProperty('timeZone')) {
        obj['timeZone'] = ApiClient.convertToType(data['timeZone'], 'String');
      }
      if (data.hasOwnProperty('isActive')) {
        obj['isActive'] = ApiClient.convertToType(data['isActive'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * Required. The name of the account. It can't be duplicated, must be unique in the GIS Server.
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * Required. The nick name of the account.
   * @member {String} nickName
   */
  exports.prototype['nickName'] = undefined;
  /**
   * Required. The Email address of the account. It can't be duplicated, must be unique in the GIS Server.
   * @member {String} email
   */
  exports.prototype['email'] = undefined;
  /**
   * Optional. The desciprition of the account.
   * @member {String} description
   */
  exports.prototype['description'] = undefined;
  /**
   * The timezone of the account. It will be used to convert some data records datetime. For example, the statistics records. Defaults to \"UTC\".
   * @member {String} timeZone
   */
  exports.prototype['timeZone'] = undefined;
  /**
   * Optional. A value indicates that whether the account is active or not. Defaults to true.
   * @member {Boolean} isActive
   */
  exports.prototype['isActive'] = undefined;



  return exports;
}));



